import { api } from 'API'
import { getAdminPasswordHeaders } from 'API/adminPassword'

interface ReleaseNote {
  id?: number
  version: string
  title: string
  content: string
  releaseDate: string
  published: boolean
  sortOrder: number
}

// The admin page has no signed-in session, so it reads with the admin password.
export const getReleaseNotes = async (options: { asAdmin?: boolean } = {}): Promise<ReleaseNote[]> => {
  const headers = options.asAdmin ? getAdminPasswordHeaders() : undefined
  const response = await api.get<ReleaseNote[]>('/release-notes', { headers })
  return response.data
}

export const getPublishedReleaseNotes = async (): Promise<ReleaseNote[]> => {
  const response = await api.get<ReleaseNote[]>('/release-notes/published')
  return response.data
}

export const getReleaseNote = async (id: number): Promise<ReleaseNote> => {
  const response = await api.get<ReleaseNote>(`/release-notes/${id}`)
  return response.data
}

export const createReleaseNote = async (releaseNote: Omit<ReleaseNote, 'id'>): Promise<ReleaseNote> => {
  const response = await api.post<ReleaseNote>('/release-notes', releaseNote, { headers: getAdminPasswordHeaders() })
  return response.data
}

export const updateReleaseNote = async (id: number, releaseNote: Partial<ReleaseNote>): Promise<void> => {
  await api.patch(`/release-notes/${id}`, releaseNote, { headers: getAdminPasswordHeaders() })
}

export const deleteReleaseNote = async (id: number): Promise<void> => {
  await api.delete(`/release-notes/${id}`, { headers: getAdminPasswordHeaders() })
}

export const formatReleaseNoteWithAI = async (
  content: string,
  version: string,
  title?: string
): Promise<{ formattedTitle: string; formattedContent: string }> => {
  const response = await api.post<{ formattedTitle: string; formattedContent: string }>(
    '/release-notes/ai-format',
    {
      content,
      version,
      title
    },
    { headers: getAdminPasswordHeaders() }
  )
  return response.data
}

export const generateReleaseNoteWithAI = async (
  changes: string[],
  version: string
): Promise<{ suggestedTitle: string; formattedContent: string }> => {
  const response = await api.post<{ suggestedTitle: string; formattedContent: string }>(
    '/release-notes/ai-generate',
    {
      changes,
      version
    },
    { headers: getAdminPasswordHeaders() }
  )
  return response.data
}
